import React, {useContext,useEffect, useState} from "react";
import { ConquerContext } from "../../contexts/ConquerContext";
import { UserContext } from "../../contexts/UserContext";
import UserPhoto from "../UserPhoto";
import { Link } from "react-router-dom";
import styles from './FriendsList.module.sass'
import AddIcon from '@mui/icons-material/Add';

const FriendsList = ({}) => {

    const userContext = useContext( UserContext );
    const conquer = useContext( ConquerContext );

    const [friends, setFriends] = useState([]);

    useEffect( () => {

        async function doWork(){

            if( !userContext.userData.isLogged ) return setFriends([]);

            let response = await conquer.Friends.get(true);
            setFriends([...response]);

        }
        doWork();

    }, [userContext.userData]);

    // if( !userContext.userData.isLogged || !friends || friends.length == 0 ) return <></>;

    function getRemainingButtons(){

        let final = [];

        for( let i = 0; i < 6 - friends.length; i++ ){
            final.push(
                <li key={i}>
                    <Link to={'/chat'} className={styles.friendLink}>
                        <AddIcon/>
                    </Link>
                </li>
            );
        }

        return final;

    }

    return (
        <ul>
            {
                friends.map( (data) => {
                    return (
                        <li key={data.avatarID}>
                            <Link to={'/chat'} className={styles.friendLink}>
                                <UserPhoto data={data} online={true}/>
                            </Link>
                        </li>
                    )
                } )
            }
            {
                friends.length < 6 && getRemainingButtons().map( (button) => {
                    return button;
                } )
            }
        </ul>
    )

};

export default FriendsList;